export const TYPE_ORGANIZATION = 'organization';
export const TYPE_PROJECT = 'project';
export const TYPE_LIVE_ROOM = 'live-room';

/**
 * Create new listing invite for redux store.
 *
 * @param {object} invitedUserId
 * @param {array} isPending
 *
 * @return {object} new listing invite
 */
export const createNewListingInvite = (
  invitedUserId,
  email,
  formValues,
  isPending = true,
  existing = false
) => ({
  id: invitedUserId,
  email,
  pending: isPending,
  existing,
  ...formValues,
});

/**
 * Create new organization invite for redux store.
 *
 * @param {object} currentUser
 * @param {array} organizationIds
 *
 * @return {object} new organization invite
 */
export const createNewOrganizationInvite = (user, organizationIds) => ({
  id: user.id.uuid,
  email: user.attributes.email,
  existing: !!user.type,
  organizationIds,
});

/**
 * Filter results users from payload.
 *
 * @param {array} userIds
 * @param {array} payloadIds
 *
 * @return {array} user entities
 */
export const filterPayloadUsers = (userIds, payloadIds) => {
  if (!userIds || !payloadIds) {
    return [];
  }

  return userIds.filter(u => payloadIds.includes(u.id.uuid));
};

/**
 * Save array to publicData. Null will remove the extended data value
 * if the array is empty.
 *
 * @param {Array} array
 *
 * @return {Array|Null}
 */
export const saveArrayToExtendedData = array => (array.length > 0 ? array : null);

/**
 * Create user entity from the payload data.
 *
 * @param {object} data response data
 *
 * @return {object} user entity
 */
export const userEntity = data => ({
  id: data.id,
  type: data.type || 'user',
});
